import { Component, OnInit, Input, Inject } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UpaegService } from '../../services/upaeg.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
// import { Ufisica } from '../../models/ufisica';
import {CurpValidator} from '../../validators/validator';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmPopComponent} from '../confirm-pop/confirm-pop.component';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';

@Component({
  selector: 'app-vinculate-upaeg',
  templateUrl: './vinculate-upaeg.component.html',
  styleUrls: ['./vinculate-upaeg.component.css'],
  providers: [UserService, UpaegService],
})
export class VinculateUpaegComponent implements OnInit {
  public sessionActive: boolean;
  public message: string;
  public status: string;
  public create: boolean;
  public step = 1;
  public upaegs = [];
  form: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private upaegSerivice: UpaegService,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) { 
    this.form = this.fb.group({
      curp: ['', [Validators.required, CurpValidator]]
    });
    this.create = false;
    this.step = 1;
  }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
   this.watchMyUpaegs();
  }

  alertDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  watchMyUpaegs() {
    this.upaegSerivice.getMyUpaegs().subscribe(result => {
      console.log(result);
      if (result.status) {
        this.router.navigate(['/misupaegs']);
      }
    }, error => {
        console.log(error);
        this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });
  }

  gotoSearch() {
    this.step = 1;
  }

  alertDialogRedirect(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/misupaegs']);
    });
  }

  openDialog(idProductor): void {


    const dialogRef = this.dialog.open(ConfirmPopComponent, {
      width: '40%',
      data: {
        titulo: '¿Enlazar Unidad de producción?',
        texto: '¿Desea vincular la unidad de producción seleccionada a su cuenta?',
        confirm: 'Enlazar unidad de producción',
        cancel: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let parametros = { 'idProductor' : idProductor};
        this.upaegSerivice.vinculateUpaeg(parametros).subscribe(response => {
          console.log(response);
          if (response.status) {
            this.alertDialogRedirect('Guardado', response.message, 'Cerrar');
          } else {
            this.alertDialog('Error', response.message, 'Cerrar');
          }
        } , error => {
          console.log(error);
          this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
        });
      }
    });



  }

  vinculate(idProductor) {
    this.openDialog(idProductor);
  }


  onSubmit(searchForm) {
    console.log(this.form.value);
    this.upaegSerivice.buscarUpaeg(this.form.get('curp').value).subscribe(response => {
      if (response.status) {
        console.log(response);
        this.create = true;
        this.upaegs = response.data;
        this.step = 2;
        this.message = '';
        this.status = '';
      } else {
        if (response.fatal) {
          this.message = 'No se pudo procesar su solicitud en este momento [500]';
          this.status = 'error';
        } else {
          this.create = true;
          this.step = 3;
          this.message = '';
          this.status = '';
        }
      }

    }, error => {
      this.message = 'No se pudo procesar su solicitud en este momento [500]';
      this.status = 'error';
    });
    
  }


}
